<template>
  <section>
    <div class="pop-room material-detail-pop" v-if="detailStatus">
      <a href="javascript:;" @click="closeDetailStatus()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <h3 class="title">材料调拨单</h3>
        <el-col :span="23" v-if="materialInData">
          <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;">
            <el-form-item label="调出仓库:">
              {{materialInData.outHouse.name}}
            </el-form-item>
            <el-form-item label="调入仓库:">
              {{materialInData.inHouse.name}}
            </el-form-item>
            <el-form-item label="调拨操作人:">
              <user-info :userData='materialInData.creator'></user-info>
            </el-form-item>
            <el-form-item label="调拨时间:">
              {{materialInData.time}}
            </el-form-item>
            <!-- <el-form-item label="总金额(元):">
              {{materialInData.total}}
            </el-form-item> -->
            <el-form-item class="full" label="材料明细:">
              <div class="material-table">
                <el-table :data="materialInData.materials" border>
                  <el-table-column prop="number" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="name" label="明细名称" width="240">
                  </el-table-column>
                  <el-table-column prop="dlName" label="材料类别" width="200">
                  </el-table-column>
                  <el-table-column prop="" align="center" label="数量">
                    <template slot-scope="scope">
                      {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="unitName" align="center" label="计量单位">
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    props: ['detailStatus', 'materialInData'],
    methods: {
      closeDetailStatus() {
        this.$emit("hideDetail")
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/components/materialAllotDetail.vue